import {
  MantineReactTable,
  useMantineReactTable,
  MRT_GlobalFilterTextInput,
  MRT_ShowHideColumnsButton,
} from 'mantine-react-table'
import { useTranslation } from 'react-i18next'
import { getLocalization } from '@/widgets/LanguageSelect/lib/consts'
import { useLogTable } from '../lib/use-log-table'

export const SMTPLogTable = () => {
  const {
    pagination,
    sorting,
    columns,
    fetchedEmailLog,
    totalRowCount,
    isErrorEmailLog,
    isFetchingEmailLog,
    isLoadingEmailLog,
    setSorting,
    setPagination,
    handleSearchChange,
  } = useLogTable()

  const { t, i18n } = useTranslation()
  const localization = getLocalization(i18n.language)

  const table = useMantineReactTable({
    columns,
    data: fetchedEmailLog,
    enableStickyHeader: false,
    manualPagination: true,
    manualSorting: true,
    enableRowActions: false,
    enableColumnActions: false,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    rowCount: totalRowCount,
    mantineSearchTextInputProps: {
      placeholder: t('contact:search'),
    },
    localization,
    onGlobalFilterChange: handleSearchChange,
    renderTopToolbar: ({ table }) => {
      return (
        <div className='flex flex-row items-center justify-between mb-2'>
          <MRT_GlobalFilterTextInput table={table} />
          <div className='flex flex-row items-center space-x-2'>
            <MRT_ShowHideColumnsButton className='h-[2.5rem] w-[2.5rem] rounded-md' table={table} />
          </div>
        </div>
      )
    },
    mantineToolbarAlertBannerProps: isErrorEmailLog
      ? {
          color: 'red',
          children: 'Error loading data',
        }
      : undefined,
    mantinePaperProps: {
      shadow: 'none',
      withBorder: false,
    },
    mantineTableProps: {
      sx: {
        tableLayout: 'auto',
      },
    },
    mantineTableBodyProps: {
      sx: {
        '&: td': {
          minWidth: 90,
        },
        '& tr:hover': {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    mantineTableBodyRowProps: {
      className: 'hover:bg-[#F4FAFD]/10',
    },
    state: {
      isLoading: isLoadingEmailLog,
      pagination,
      sorting,
      showGlobalFilter: true,
      showAlertBanner: isErrorEmailLog,
      showProgressBars: isFetchingEmailLog,
    },
  })

  return <MantineReactTable table={table} />
}
